import { ConfigProvider } from 'antd';
import './App.css';
import { UserContextProvider } from './Contexts/user';
import AppRoutes from './Routes/AppRoutes';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#009B69",
          boxShadow: "none",
        },
      }}
    >
    <UserContextProvider>
      <AppRoutes />
    </UserContextProvider>
    </ConfigProvider>
  );
}

export default App;
